module.exports = __webpack_public_path__ + "media/images/icons/cancel-f293d335120f33fcd012e69dbe4cf0a4.svg";